import React, { useState, useRef, useEffect, useMemo } from 'react'
import styled from 'styled-components'
import ColumnConfigurationPopup from './ColumnConfigurationPopup'
import { injectIntl } from 'react-intl'
import useWindowSize from '../common3/hooks/useWindowSize'
import get from 'lodash/get'

const Wrapper = styled.div`
  padding: 5px 5px;
  position: absolute;
  top: -14.5px;
  background-color: #ddd;
  border-radius: 50%;
  z-index: 2;
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #fff;
  cursor: pointer;
`

const OpenIcon = styled.em`
  font-size: 20px;
  color: #777;
`

const ColumnSelector = injectIntl(({ setRowColumnConfig,intl, node,nodes }) => {
  const [open, setOpen] = useState(false)
  const [position, setPosition] = useState({})
  const [width, height] = useWindowSize()

  const thisSetRowColumnConfig = (colConfig) => {
    setOpen(false)
    setRowColumnConfig(colConfig)
  }

  const ref = useRef()

  useEffect(() => {
    setPosition(ref.current.getBoundingClientRect())
  }, [width, height])


  let maxCols = useMemo( () => {
    const { structure = [] } = node;
    let maxCols = 0;

    for (let j = structure.length - 1; j >= 0; j--) {
      const colNode = nodes[structure[j]]
      
      const colStructure = get(colNode,'structure', [])
      if( colStructure.length !== 0 ) {
        maxCols = j + 1
        break;
      }
    }

    return maxCols

  }, [node, nodes]);
  

  return (
    <Wrapper onClick={() => setOpen(!open)}>
      <IconWrapper ref={ref} data-tip={intl.formatMessage({id: 'fb3.ColumnConfiguration'})} data-place='bottom' onClick={() => setOpen(!open)} role="button" aria-label="Column configuration">
        <OpenIcon className="fal fa-ellipsis-h"  />
      </IconWrapper>

      {
        open && <ColumnConfigurationPopup setOpen={setOpen} setRowColumnConfig={thisSetRowColumnConfig} position={position} maxCols={maxCols} />
      }
    </Wrapper>
  )
})

export default ColumnSelector
